import { render, staticRenderFns } from "./ServicejobIndex.vue?vue&type=template&id=4656983c"
import script from "./ServicejobIndex.vue?vue&type=script&lang=js"
export * from "./ServicejobIndex.vue?vue&type=script&lang=js"
import style0 from "./ServicejobIndex.vue?vue&type=style&index=0&id=4656983c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports